// extracted by mini-css-extract-plugin
module.exports = {"action-dots":"styles-module__action-dots___3I9Yt","action-button":"styles-module__action-button___1oTDn"};